// Hotel staff (receptionist, spa, food & beverage, manager...) are stored with their
// hotel under user.hotel.hotel_id, but many screens read user.hotel_id and so got an
// empty hotel for them (room list showed "No options"). Fill hotel_id in on read.
const rawGetItem = Storage.prototype.getItem;
Storage.prototype.getItem = function patchedGetItem(key) {
  const value = rawGetItem.call(this, key);
  if (key !== "user" || !value) return value;
  try {
    const user = JSON.parse(value);
    if (user && typeof user === "object" && !user.hotel_id && user.hotel && user.hotel.hotel_id) {
      user.hotel_id = user.hotel.hotel_id;
      return JSON.stringify(user);
    }
  } catch (error) {
    // not JSON: leave it to the caller
  }
  return value;
};
